export const RENOVACAO_TOOLTIP_TEXT = 'Não é possível editar este campo em uma renovação de prescrição'

export const MEDICAMENTO_DEFINIDO_COMO_DOSE_COMUM_TOOLTIP_TEXT = 'Medicamento definido como dose comum'

export const MEDICAMENTO_DEFINIDO_COMO_DOSE_FRACIONADA_TOOLTIP_TEXT = 'Medicamento definido como dose fracionada'

export const MEDICAMENTO_DEFINIDO_COMO_DOSE_UNICA_TOOLTIP_TEXT = 'Medicamento definido como dose única'

export const UTILIZE_VIRGULA_OU_BARRA_DOSES_FRACIONADAS_TOOLTIP_TEXT =
  'Utilize vírgula ou barra para doses fracionadas.'

export const UTILIZE_VIRGULA_DOSES_FRACIONADAS_TOOLTIP_TEXT = 'Utilize vírgula para doses fracionadas.'

export const REGISTRO_MANUAL_TOOLTIP_TEXT = 'Utilize esta opção para preencher as informações livremente'
